import { TicketRoutes } from '@superbet-group/web.types';

import { RouteName } from '@app/router/constants/RouteName';
import {
    backAccountMenuItemId,
    MenuItem,
} from '@src/config/shell/localConfigTypes';
import { Product } from '@app/router/products/Product';

// function to avoid circular reference issue
export function getMenuItems(): MenuItem[] {
    const routeLinks = [
        {
            id: backAccountMenuItemId,
            name: 'back',
            icon: 'icon-arrow_left',
        },
        {
            id: RouteName.Account.Profile,
            name: 'my account',
            icon: 'icon-user',
        },
        {
            id: RouteName.Account.MyMessages,
            name: 'bonus_comms.inbox.my_messages',
            icon: 'icon-email',
        },
    ];
    if (Product.Sport || Product.Lottery) {
        routeLinks.push({
            id: TicketRoutes.Tickets,
            name: 'my tickets',
            icon: 'icon-ticket_2',
        });
    }
    routeLinks.push(
        {
            id: RouteName.Account.Deposit,
            name: 'deposit',
            icon: 'icon-deposit',
        },
        {
            id: RouteName.Account.Withdrawal,
            name: 'withdrawal',
            icon: 'icon-withdrawal',
        },
        {
            id: RouteName.Account.History,
            name: 'history',
            icon: 'icon-transactions',
        },
        {
            id: RouteName.Account.Settings,
            name: 'settings',
            icon: 'icon-settings',
        },
        {
            id: RouteName.Account.ResponsibleGaming,
            name: 'responsible gaming',
            icon: 'icon-responsible_gaming',
        },
        {
            id: RouteName.Account.DocumentUpload,
            name: 'document upload',
            icon: 'icon-upload_2',
        },
    );
    return routeLinks;
}
